module.exports = __webpack_public_path__ + "static/media/intro03.dd73e022.png";